export function emptyReplacementProduct() {
  return {
    title: "",
    referenceId: "",
    price: null,
    purchaseDate: "",
    currencyCode: "EUR",
    vendor: "",
    productType: "",
    imageUrl: "",
  };
}

export function replacementProductFromAnalysis(analysis) {
  if (!analysis) return emptyReplacementProduct();
  return {
    title: analysis.title ?? "",
    referenceId: analysis.referenceId ?? "",
    price: analysis.price ?? null,
    purchaseDate: analysis.purchaseDate ?? "",
    currencyCode: analysis.currencyCode ?? "EUR",
    vendor: analysis.vendor ?? "",
    productType: analysis.productType ?? "",
    imageUrl: analysis.imageUrl ?? "",
  };
}
